import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { useEffect } from 'react';
import FocusLock from 'react-focus-lock';
import { useTranslation } from 'react-i18next';

import '../styles/componentsStyles/ChallengeErrorModal.css';
import { Button } from '../../shared/components/button/Button';

function ChallengeErrorModal({ subtitle, onClose, returnFocus }) {
  const { t } = useTranslation();

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <FocusLock returnFocus={returnFocus}>
      <div className="popup-overlay" role="dialog" aria-modal="true">
        <span className="sr-only">{t('modal.challenge.error')}</span>
        <div className="dark-container challenge-error">
          <div className="challenge-error-subtitile">
            {subtitle}
            <a
              href="https://support.championhealth.co.uk/"
              target="_blank"
              rel="noopener noreferrer"
              className="challenge-error-link"
            >
              {t('CH042')}
            </a>
          </div>

          <Button
            onClick={onClose}
            color="white"
            icon={{ faIconDefinition: faArrowRight, size: 'lg' }}
          >
            {t('M012')}
          </Button>
        </div>
      </div>
    </FocusLock>
  );
}

export default ChallengeErrorModal;
